import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Rnd } from 'react-rnd';
import _ from 'lodash';
import { Icon } from '@gisatcz/ptr-atoms'; // TODO handle sizes in rem

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MIN_WIDTH = 100;
var MIN_HEIGHT = 100;
var MAX_WIDTH = 'auto';
var MAX_HEIGHT = 'auto';

var Window = function Window(_ref) {
  var containerHeight = _ref.containerHeight,
      containerWidth = _ref.containerWidth,
      content = _ref.content,
      icon = _ref.icon,
      onDragStart = _ref.onDragStart,
      onDragStop = _ref.onDragStop,
      onClick = _ref.onClick,
      onCloseClick = _ref.onCloseClick,
      onResize = _ref.onResize,
      title = _ref.title,
      windowKey = _ref.windowKey,
      withoutHeader = _ref.withoutHeader,
      height = _ref.height,
      width = _ref.width,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth;

  var onClickSelf = function onClickSelf() {
    if (onClick) {
      onClick(windowKey);
    }
  };

  var onCloseSelf = function onCloseSelf(e) {
    e.stopPropagation();

    if (onCloseClick) {
      onCloseClick(windowKey);
    }
  };

  var onDragStartSelf = function onDragStartSelf() {
    if (onDragStart) {
      onDragStart(windowKey);
    }
  };

  var calculatePositionFromXY = function calculatePositionFromXY(x, y, width, height) {
    var topDiff = y;
    var bottomDiff = containerHeight - (y + height);
    var leftDiff = x;
    var rightDiff = containerWidth - (x + width);
    var position = {
      top: null,
      bottom: null,
      left: null,
      right: null
    };

    if (topDiff > bottomDiff && bottomDiff > 0) {
      position.bottom = bottomDiff;
    } else {
      position.top = topDiff;
    }

    if (leftDiff > rightDiff && rightDiff > 0) {
      position.right = rightDiff;
    } else {
      position.left = leftDiff;
    }

    return position;
  };

  var onDragStopSelf = function onDragStopSelf(e, data) {
    var position = calculatePositionFromXY(data.x, data.y, width, height); // TODO find better way

    var isTargetCloseButton = e.target.className && e.target.className === 'ptr-window-control close';

    var isParentCloseButton = _.find(e.path, function (element) {
      return element.className === 'ptr-window-control close';
    });

    if (isTargetCloseButton || isParentCloseButton) {
      onCloseSelf(e);
    } else if (onDragStop) {
      onDragStop(windowKey, position);
    }
  };

  var onResizeSelf = function onResizeSelf(e, direction, ref, delta, coord) {
    if (onResize) {
      var _position = calculatePositionFromXY(coord.x, coord.y, ref.offsetWidth, ref.offsetHeight); // console.log(position, ref.offsetWidth, ref.offsetHeight , direction, delta);


      onResize(windowKey, ref.offsetWidth, ref.offsetHeight, _position); // TODO check
    }
  };

  var renderControls = function renderControls(fixed) {
    var classes = classNames('ptr-window-controls', {
      fixed: fixed
    });
    return /*#__PURE__*/_jsx("div", {
      className: classes,
      children: /*#__PURE__*/_jsx("div", {
        className: "ptr-window-control close",
        onClick: onCloseSelf,
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "close"
        })
      })
    });
  };

  var renderHeader = function renderHeader(handleClass) {
    var headerClasses = 'ptr-window-header ' + handleClass;
    return /*#__PURE__*/_jsxs("div", {
      className: headerClasses,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "ptr-window-title",
        title: title,
        children: [icon ? /*#__PURE__*/_jsx(Icon, {
          icon: icon
        }) : null, title]
      }), renderControls()]
    });
  };

  var renderContent = function renderContent() {
    return /*#__PURE__*/_jsx("div", {
      className: "ptr-window-content",
      children: content
    });
  };

  var calculateXYfromPosition = function calculateXYfromPosition(width, height) {
    var top = position.top;
    var bottom = position.bottom;
    var left = position.left;
    var right = position.right;
    var x = 0;
    var y = 0;

    if (top || top === 0) {
      if (top + height < containerHeight) {
        y = top;
      } else {
        y = containerHeight - height;
      }
    } else {
      if (bottom + height < containerHeight) {
        y = containerHeight - (bottom + height);
      } else {
        y = 0;
      }
    }

    if (left || left === 0) {
      if (left + width < containerWidth) {
        x = left;
      } else {
        x = containerWidth - width;
      }
    } else {
      if (right + width < containerWidth) {
        x = containerWidth - (right + width);
      } else {
        x = 0;
      }
    }

    return {
      x: x,
      y: y
    };
  };

  var handleClass = 'ptr-window-handle';
  var classes = classNames('ptr-window', _defineProperty({}, handleClass, !!withoutHeader));
  var renderWidth = width ? width : 'auto';
  var renderHeight = height ? height : 'auto';

  if (renderWidth > containerWidth && containerWidth) {
    renderWidth = containerWidth;
  }

  if (renderHeight > containerHeight && containerHeight) {
    renderHeight = containerHeight;
  }

  var position = calculateXYfromPosition(renderWidth, renderHeight);
  return /*#__PURE__*/_jsxs(Rnd, {
    bounds: "parent",
    className: classes,
    dragHandleClassName: handleClass,
    minWidth: minWidth ? minWidth : MIN_WIDTH,
    minHeight: minHeight ? minHeight : MIN_HEIGHT,
    maxWidth: maxWidth ? maxWidth : MAX_WIDTH,
    maxHeight: maxHeight ? maxHeight : MAX_HEIGHT,
    onDragStop: onDragStopSelf,
    onDragStart: onDragStartSelf,
    onClick: onClickSelf,
    onResize: onResizeSelf,
    position: {
      x: position.x,
      y: position.y
    },
    size: {
      renderWidth: renderWidth,
      renderHeight: renderHeight
    },
    children: [withoutHeader ? renderControls(true) : renderHeader(handleClass), renderContent()]
  });
};

Window.propTypes = {
  containerHeight: PropTypes.number,
  containerWidth: PropTypes.number,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  icon: PropTypes.string,
  onDragStart: PropTypes.func,
  onDragStop: PropTypes.func,
  onClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onResize: PropTypes.func,
  title: PropTypes.string,
  windowKey: PropTypes.string,
  withoutHeader: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number
};
export default Window;